module.exports = __webpack_public_path__ + "static/media/1.e22ba60a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16102/1.jpg
// module id = 535
// module chunks = 0